import { CssTheming } from './CssTheming';
import { GenericTheming } from './GenericTheming';
import { ThemeId } from '../common/EnumTypes';
import { ThemingConfig } from '../config/ThemingConfig';
import { ContextDataController } from '../data/ContextDataController';

export class Theming {
	private _genericTheming: GenericTheming | undefined;
	private _cssTheming: CssTheming | undefined;

	get genericTheming(): GenericTheming | undefined {
		return this._genericTheming;
	}
	get cssTheming(): CssTheming | undefined {
		return this._cssTheming;
	}

	public async initialize(themingConfig: ThemingConfig, contextDataController: ContextDataController) {
		this._genericTheming = new GenericTheming(themingConfig, contextDataController);
		this._cssTheming = new CssTheming(themingConfig);
		await this._cssTheming.initialize();
	}

	public updateCurrentTheme(themeId: ThemeId) {
		this._genericTheming?.updateCurrentTheme(themeId);
		this._cssTheming?.updateCurrentTheme(themeId);
	}
}
